export enum breadcrumbsControlTypes {
  SET_ACCORDION_STEP = 'accordionStep/set',
  SET_STEP_CHANGE_TO = 'accordionStep/setStepChangeTo',
}

export interface AccordionStepAction {
  type: breadcrumbsControlTypes.SET_ACCORDION_STEP;
  accordionStep: number;
}

export interface SetStepChangeAction {
  type: breadcrumbsControlTypes.SET_STEP_CHANGE_TO;
  stepChangeTo: number;
}

export type Actions = AccordionStepAction | SetStepChangeAction;
